<template>
    <project-template>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>The Backstory</h1>
          <p>I was solely responsible for developing the Milk* website during my internship with the agency in Summer 2017. I built the core of the site and all of its functionality using HTML, Sass, and vanilla Javascript. I then handed it off to a WordPress developer for theming, implementing custom fields, and blog integration.</p>
        </project-text>

        <project-video
        size="75"
        videoID="350439694"
        :gif="true"/>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>The Results</h1>
          <p>Well, the agency certainly got a lot of compliments on the facelift. After the site went live, Milk* began to notice an uptick in requests for website work. A review of Google Analytics after the launch also indicated that users were spending a longer time exploring the site and viewing the agency’s work. In general, the site also received more hits and a lower bounce rate compared to the former website.</p>
        </project-text>

        <project-image
        size="50"
        path="/img/p/milksite/blogandmenu.jpg"
        alt="Milk Website Blog and Menu Renders"/>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>What Would I Do Differently Today?</h1>
          <p>The site makes use of several Javascript libraries to provide meaningful and fun interactions, and is brimming with custom-built animations. However, if I were to re-develop the site knowing what I know today, I might sacrifice some flashy features for the sake of performance, and focus more on page speed optimization. I would also make use of more recent standards  in web development, such as CSS Grid, Node.Js, and webpack.<br><br>To see a more recent example of my front-end development work, <router-link to="portfolio">read more</router-link> about DanAraujo.com.</p>
        </project-text>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectImage from '../../components/project/ProjectImage.vue'
import ProjectText from '../../components/project/ProjectText.vue'
import ProjectVideo from '../../components/project/ProjectVideo.vue'

export default {
  components: { ProjectTemplate, ProjectText, ProjectImage, ProjectVideo }
}
</script>

<style lang="scss" scoped>

</style>
